if (!customElements.get('cross-sell-module')) {
  customElements.define(
    'cross-sell-module',
    class CrossSellModule extends HTMLElement {
      connectedCallback() {
        this.moneyFormat = this.dataset.moneyFormat || '£{{amount}}';
        this.totalEl = this.querySelector('[data-total-price]');
        this.quantityInput = this.querySelector('[data-bundle-quantity]');
        this.submitButton = this.querySelector('[data-add-bundle]');
        this.errorEl = this.querySelector('[data-error-message]');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.querySelectorAll('.cross-sell-module__item[data-line-type="main"]').forEach((item) => {
          item.remove();
        });

        this.querySelectorAll('.cross-sell-module__divider').forEach((divider) => {
          divider.remove();
        });

        this.querySelectorAll('.cross-sell-module__item').forEach((item) => {
          const checkbox = item.querySelector('.cross-sell-module__checkbox');
          const variantSelect = item.querySelector('[data-variant-select]');

          if (checkbox && !checkbox.disabled) {
            checkbox.addEventListener('change', () => {
              item.classList.toggle('is-selected', checkbox.checked);
              item.dataset.selected = checkbox.checked ? 'true' : 'false';
              this.updateTotals();
            });
          }

          if (variantSelect) {
            variantSelect.addEventListener('change', () => {
              this.updateLinePrice(item);
              this.updateTotals();
            });
            variantSelect.addEventListener('click', (event) => event.stopPropagation());
          }
        });

        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', () => this.updateTotals());
        }

        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onAddBundle.bind(this));
        }

        this.updateTotals();
      }

      getVariantPriceCents(item) {
        const variantSelect = item.querySelector('[data-variant-select]');
        if (!variantSelect) return 0;

        if (variantSelect.tagName === 'SELECT') {
          const option = variantSelect.options[variantSelect.selectedIndex];
          return Number(option?.dataset.price || 0);
        }

        return Number(variantSelect.dataset.price || 0);
      }

      getVariantId(item) {
        const variantSelect = item.querySelector('[data-variant-select]');
        if (!variantSelect) return null;
        return variantSelect.value;
      }

      updateLinePrice(item) {
        const priceEl = item.querySelector('[data-line-price]');
        if (!priceEl) return;
        priceEl.textContent = this.formatMoney(this.getVariantPriceCents(item));
      }

      updateTotals() {
        let subtotal = 0;

        this.querySelectorAll('.cross-sell-module__item').forEach((item) => {
          if (!this.isItemSelected(item)) return;
          subtotal += this.getVariantPriceCents(item);
        });

        const quantity = Math.max(1, Number(this.quantityInput?.value || 1));
        if (this.totalEl) {
          this.totalEl.textContent = this.formatMoney(subtotal * quantity);
        }
      }

      isItemSelected(item) {
        const checkbox = item.querySelector('.cross-sell-module__checkbox');
        return Boolean(checkbox?.checked);
      }

      formatMoney(cents) {
        const amount = (Number(cents) / 100).toFixed(2);
        const withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma);
      }

      getSelectedItems() {
        const quantity = Math.max(1, Number(this.quantityInput?.value || 1));
        const items = [];

        this.querySelectorAll('.cross-sell-module__item').forEach((item) => {
          if (!this.isItemSelected(item)) return;

          const id = this.getVariantId(item);
          if (!id) return;

          items.push({ id: Number(id), quantity });
        });

        return items;
      }

      onAddBundle(event) {
        event.preventDefault();
        const items = this.getSelectedItems();
        if (!items.length || !this.submitButton) return;

        this.hideError();
        this.submitButton.classList.add('loading');
        this.submitButton.setAttribute('aria-disabled', 'true');

        const body = { items };
        const config = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify(body),
        };

        fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || 'Unable to add items to cart.');
              return;
            }

            if (typeof publish === 'function') {
              publish(window.PUB_SUB_EVENTS?.cartUpdate || 'cart-update', {
                source: 'cross-sell-module',
                cartData: response,
              });
            }

            if (this.cart) {
              const sectionIds = this.cart.getSectionsToRender().map((section) => section.id);
              return fetch(`${window.location.pathname}?sections=${sectionIds.join(',')}`)
                .then((res) => res.json())
                .then((sections) => {
                  this.cart.renderContents({ ...response, sections });
                });
            }

            window.location = window.routes?.cart_url || '/cart';
          })
          .catch(() => {
            this.showError('Unable to add items to cart.');
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
          });
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.classList.remove('hidden');
      }

      hideError() {
        if (!this.errorEl) return;
        this.errorEl.textContent = '';
        this.errorEl.classList.add('hidden');
      }
    }
  );
}
